<nb-card>
    <full-calendar [options]="calendarOptions"></full-calendar>
</nb-card>

